/**
 * Builder-only per-block DOM hook for the canvas "select mode".
 *
 * In EDIT mode this returns `{ 'data-aqx-block-id': blockId }` to spread onto a block's EXISTING root element
 * (a card div, a `<tr>`, an `<li>`, …) — NEVER a new wrapper, so grid/table/flex layout is untouched. The
 * builder canvas then resolves which block a click hit via `closest('[data-aqx-block-id]')`.
 *
 * In LIVE mode it returns `{}` — the storefront DOM is byte-identical (the attribute never leaks to customers,
 * no SSR/CLS/a11y impact). Usage on a block root:
 *
 *   <div className={`${cls}__card`} {...editBlockAttrs(block.id, context)}>…</div>
 */
export function editBlockAttrs(blockId, ctx) {
    return ctx.renderMode === 'edit' ? { 'data-aqx-block-id': blockId } : {};
}
/**
 * Builder-only per-FIELD DOM hook for PART-LEVEL selection ("field hotspots").
 *
 * Mirrors {@link editBlockAttrs}, but for a SETTING that renders as a concrete element instead of a child
 * block — a heading `<h2>` bound to `settings.title`, a CTA `<a>` bound to `settings.buttonLabel`, an
 * `<img>` bound to `settings.image`, … These are NOT blocks (no entry in `section.blocks[]`), so the block
 * hook can't reach them; a click on the rendered title otherwise only ever selects the whole section.
 *
 * In EDIT mode this returns `{ 'data-aqx-field-id': fieldId }` to spread onto that element's EXISTING root
 * — NEVER a new wrapper, so layout is untouched. The builder canvas resolves the clicked field via
 * `closest('[data-aqx-field-id]')`, draws a frame on it, and jumps the inspector straight to that field's
 * control (the `fieldId` is the schema `field.id`, e.g. `'title'`). In LIVE mode it returns `{}` — the
 * storefront DOM stays byte-identical (the attribute never reaches a customer; no SSR/CLS/a11y impact).
 *
 *   <h2 {...editFieldAttrs('title', context)} dangerouslySetInnerHTML={{ __html: headingHtml }} />
 */
export function editFieldAttrs(fieldId, ctx) {
    return ctx.renderMode === 'edit' ? { 'data-aqx-field-id': fieldId } : {};
}
//# sourceMappingURL=editAttrs.js.map